

import * as React from "react";
import {Api} from "../../../lib/Api";
import Header from "../../Header";
import Footer from "../../Footer";

interface IReviewProps {
    order: any
    setUrl: any


}


interface IReviewState {
    rating: number
    comment: string
}

export default class UserReview extends React.Component<IReviewProps, IReviewState>{

    constructor(props:IReviewProps){
        super(props);
        this.state = {
            rating: 0,
            comment: ''
        }
    }

    private setRateingClickHandler(evt, value:number): void {
        evt.preventDefault();
        this.setState({
            rating: value
        });

    }

    private sendRating(){
        Api.call('/user/order/review', {
            order: this.props.order,
            rating: this.state.rating,
            comment: this.state.comment

        }, (result) => {
            if(result.rating) {
                this.props.setUrl('/user/index');
            }
        });
    }



    render() {
        let order = this.props.order;

        return (
            <div className = "order-review">
                <Header
                    setUrl={this.props.setUrl}
                />
                <section className="content_section container">
                    <div className="row">
                        <h1>How satisfied are you?</h1>
                        <div className = "col-md-12">
                            <div className = "main-content">
                                <div className = "profile-image">
                                    <div className = "image">
                                        <img src="https://api.opus.ecom-hosting.hu/uploads/restaurant/83/photo_0.jpg?tms=1676046635" />
                                    </div>
                                </div>

                                <div className = "content">
                                    <p className="name">{order.offer.creator.name}</p>
                                    <p className="offer-type">{order.offer.offerType.name}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="rateing_row">
                                <a onClick={ (e) => { this.setRateingClickHandler(e, 1); } }>
                                    <img src={ this.state.rating>=1?'img/star_icon.svg':'img/star_empty_icon.svg'} alt="" width={45} />
                                </a>
                                <a onClick={ (e) => { this.setRateingClickHandler(e, 2); } }>
                                    <img src={ this.state.rating>=2?'img/star_icon.svg':'img/star_empty_icon.svg'} alt="" width={45} />
                                </a>
                                <a onClick={ (e) => { this.setRateingClickHandler(e, 3); } }>
                                    <img src={ this.state.rating>=3?'img/star_icon.svg':'img/star_empty_icon.svg'} alt="" width={45} />
                                </a>
                                <a onClick={ (e) => { this.setRateingClickHandler(e, 4); } }>
                                    <img src={ this.state.rating>=4?'img/star_icon.svg':'img/star_empty_icon.svg'} alt="" width={45} />
                                </a>
                                <a onClick={ (e) => { this.setRateingClickHandler(e, 5); } }>
                                    <img src={ this.state.rating>=5?'img/star_icon.svg':'img/star_empty_icon.svg'} alt="" width={45} />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                           <textarea className="s-form-control" name="comment" rows={8} placeholder={"Please help us by describing why you think so"}
                                     onChange={(e) => this.setState({
                                         comment: e.target.value
                                     })}></textarea>
                        </div>
                    </div>

                    <div className = "form-row">
                        <div className="col">
                            <div className = "upload_photo_box">
                                <p>Upload your photos</p>
                                <img src = "/img/upload_photo_icon.png"  alt={""}/>
                            </div>
                        </div>
                    </div>

                    <div className = "form-row">
                        <div className = "col">
                            <p className = "purple-text">Thank you!</p>
                            <div className = "order-btn">
                                <button type="button" className="purple_btn" onClick={(e) => this.sendRating()}>Send</button>
                            </div>
                        </div>
                    </div>

                    <div className = "form-row">
                        <div className = "col">
                            <div className = "back-btn">
                                <button className="back_btn" onClick={() => this.props.setUrl('/user/index')}>Back to services</button>
                            </div>
                        </div>
                    </div>
                </section>

                <Footer homePageMode={Api.isFrontUser()} setUrl={this.props.setUrl}></Footer>
            </div>
        );
    }
}
